var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .077a7.923 7.923 0 100 15.846A7.923 7.923 0 008 .077zm0 13.306a.96.96 0 11-.001-1.92.96.96 0 01.001 1.92zm1.44-4.159a.856.856 0 00-.48.793v.497a.243.243 0 01-.07.17.243.243 0 01-.17.07H7.28a.24.24 0 01-.24-.24v-.497a2.774 2.774 0 011.596-2.54c.57-.258.927-.837.9-1.462A1.56 1.56 0 008.06 4.54a1.532 1.532 0 00-1.596 1.54.238.238 0 01-.071.169.238.238 0 01-.17.07h-1.44a.24.24 0 01-.24-.24 3.457 3.457 0 016.23-2.07A3.461 3.461 0 019.44 9.224z",
    strokeWidth: 0,
    fill: "#AB7DCC",
    fillRule: "evenodd"
  })));
}

export default SvgIconQuestionCircle;